<template>
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="29"
      cy="29"
      r="28.5"
      stroke="#142B6F"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      class="a-fill"
      cx="13"
      cy="5"
      r="3"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      class="a-fill"
      cx="47"
      cy="51"
      r="3"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M29.9059 17.942C30.2375 17.0785 30.8185 16.336 31.5734 15.8112C32.3284 15.2864 33.2221 15.0038 34.1382 15C34.2718 15 34.4 15.0537 34.4945 15.1492C34.589 15.2447 34.642 15.3743 34.642 15.5094C34.642 15.6445 34.589 15.7741 34.4945 15.8697C34.4 15.9652 34.2718 16.0189 34.1382 16.0189C33.4271 16.021 32.7332 16.2396 32.1468 16.6463C31.5604 17.0529 31.1087 17.6287 30.8506 18.2986C30.8114 18.3949 30.7452 18.4776 30.6602 18.5364C30.5752 18.5952 30.475 18.6276 30.372 18.6297C30.3112 18.6294 30.2512 18.6164 30.1957 18.5915C30.1339 18.5689 30.0772 18.534 30.029 18.4888C29.9808 18.4437 29.942 18.3892 29.915 18.3287C29.888 18.2681 29.8733 18.2027 29.8717 18.1362C29.8702 18.0698 29.8818 18.0038 29.9059 17.942ZM40.9652 34.9189C39.2773 39.0962 36.2669 42 33.6344 42H24.5653C20.7865 42 16 35.7594 16 28.7547C15.9991 27.2186 16.4274 25.7136 17.2357 24.413C18.044 23.1123 19.1993 22.0691 20.5685 21.4036C21.9376 20.738 23.465 20.4772 24.9744 20.6511C26.4838 20.8251 27.9139 21.4267 29.0998 22.3868C29.9315 21.7158 30.8862 21.2177 31.9089 20.921C32.9316 20.6244 34.0022 20.535 35.0592 20.6581C36.1162 20.7812 37.1387 21.1143 38.068 21.6383C38.9972 22.1622 39.8149 22.8668 40.474 23.7113C40.5178 23.7685 40.5493 23.8342 40.5667 23.9044C40.584 23.9746 40.5868 24.0476 40.5747 24.1189C40.563 24.1907 40.5354 24.2589 40.4939 24.3185C40.4525 24.378 40.3983 24.4273 40.3354 24.4627C39.4872 24.9817 38.7922 25.7211 38.3228 26.604C37.8534 27.487 37.6269 28.481 37.6667 29.4826C37.7066 30.4842 38.0115 31.4566 38.5495 32.2986C39.0876 33.1405 39.8392 33.821 40.7259 34.2693C40.8374 34.3293 40.9234 34.4285 40.9675 34.5482C41.0116 34.6679 41.0108 34.7997 40.9652 34.9189ZM39.8568 34.9571C38.9272 34.398 38.1491 33.6149 37.5918 32.6777C37.0345 31.7405 36.7154 30.6784 36.663 29.5861C36.6107 28.4938 36.8266 27.4054 37.2916 26.4181C37.7565 25.4308 38.4561 24.5752 39.3277 23.9278C38.0742 22.5489 36.3345 21.7239 34.4845 21.6309C32.6344 21.538 30.8224 22.1846 29.4399 23.4311C29.3486 23.5188 29.2281 23.5687 29.1023 23.5711C28.9764 23.5735 28.8542 23.5281 28.7597 23.4439C27.7469 22.5219 26.4911 21.917 25.1449 21.7025C23.7987 21.488 22.4199 21.6731 21.1757 22.2354C19.9315 22.7976 18.8754 23.7129 18.1356 24.8701C17.3957 26.0273 17.0039 27.3768 17.0077 28.7547C17.0077 31.7094 17.965 34.8297 19.6276 37.3259C21.1392 39.5802 23.0286 40.9811 24.5653 40.9811H33.6344C35.7505 40.9811 38.3201 38.4722 39.8568 34.9571Z"
      fill="#142B6F"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  stroke: #CDD1DE;
  stroke-width: 1px;
  &.a-fill {
    fill: #CDD1DE;
  }
}

.a-active {
  &.a-fill {
      fill: #142B6F;
  }
}
</style>
